import { Popup } from '@dsee/components/popups/popup.js';

export default {
    install(Vue) {
        Vue.mixin({
            beforeCreate() {
                let computed = this.$options.computed;

                if (!computed)
                    computed = this.$options.computed = {};

                if (!this.$options.modal)
                    return;

                if (computed.$modal)
                    return;

                computed.$modal = function () {
                    const config = this.$options.modal;
                    for (const key in config) {
                        if (typeof (config[key]) === 'function') {
                            config[key] = config[key].bind(this);
                        }
                    }
                    return new Popup(config, this.$el);
                };
            },
            mounted() {
                if (this.$options.modal != null && this.$modal == null)
                    throw new Error('Modal is not created');
            },
            beforeDestroy() {
                if (this.$modal != null)
                    this.$modal.remove();
            },
        });
    },
};
